import axios from "axios";
import { axiosInstance } from "./AxiosInterceptor";
import { backendConfig } from "../config/BackendConfig";

/**
 * @param {
 *
 * } queryParam
 * @returns Promise
 */
export const getUserAuthenticationHookDetails = (queryParam) => {
  /**End Point:- userAuthenticationHook**/
  return axios.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.checkUserRegistrationStatus,
    queryParam,
    {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": backendConfig.API_KEY,
      },
    }
  );
};

/**
 * @param {
 *
 * } queryParam
 * @returns Promise
 */
export const attachIoTPolicyToCognitoIdentity = (queryParam) => {
  /**End Point:- attachIoTPolicyToCognitoIdentity**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.attachPolicy,
    queryParam
  );
};

/**
 * @param {
 *
 * } queryParam
 * @returns Promise
 */
export const updateClientDataInDB = (queryParam) => {
  /**End Point:- updateClientDataInDB**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.updateUserAppPreferences,
    queryParam
  );
};

/**
 * @param {
 * PhoneNumber: string,
* } queryParam
* @returns Promise
*/
export const sendOTP = (queryParam) => {
 /**End Point:- sendSecurityCode**/
 return axiosInstance.post(
   backendConfig.API_URL + backendConfig.API_END_POINTS.sendSecurityCode,
   queryParam
 );
};


/**
 * @param {
* PhoneNumber: string,
* OTP: number
* } queryParam
* @returns Promise
*/
export const verifyOTP = (queryParam) => {
 /**End Point:- verifyOTP**/
 return axiosInstance.post(
   backendConfig.API_URL + backendConfig.API_END_POINTS.updateUserDetails,
   queryParam
 );
};


/**
 * @param {
* attribute: string,  "email"
* value: string,   "mail-id"
* otp: number
* } queryParam
* @returns Promise
*/
export const verifySecurityCode = (queryParam) => {
 /**End Point:- verifyOTP**/
 return axios.post(
   backendConfig.API_URL + backendConfig.API_END_POINTS.verifySecurityCode,
   queryParam,
   {
    headers: {
      "Content-Type": "application/json",
      "x-api-key": backendConfig.API_KEY,
    },
  }
 );
};

